import { AlertadosComponent } from './components/alertados/alertados.component';
import { SinTransmitirComponent } from './components/sin-transmitir/sin-transmitir.component';
import { TransmisionesComponent } from './components/transmisiones/transmisiones.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientesComponent } from './components/galeria/clientes/clientes.component';
import { GaleriaVehiculosComponent } from './components/galeria/galeria-vehiculos/galeria-vehiculos.component';
import { MaquetaComponent } from './components/maqueta/maqueta.component';
import { FotografiasComponent } from './components/fotografias/fotografias.component';

const routes: Routes = [
	{
		path: '',
		children: [
			{
				path: 'alertados',
				component: AlertadosComponent
			},
			{
				path: 'clientes',
				component: ClientesComponent
			},
			{
				path: 'clientes/galeria-vehiculos/:idCliente',
				component: GaleriaVehiculosComponent

			},
			{
				path: 'fotografias',
				component: FotografiasComponent
			},
			{
				path: 'reportes/transmisiones',
				component: TransmisionesComponent
			},
			{
				path: 'reportes/sin-transmitir',
				component: SinTransmitirComponent,
			},
			{
				path:'maqueta',
				component:MaquetaComponent
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ConsolaRoutingModule { }
